import styled from "styled-components";

export const Img=styled.img`
    z-index:3;
    width:40%;
`;
